export function getView(width) {
  let newView = 'MobileView';
  if (width > 1220) {
    newView = 'DesktopView';
  } else if (width > 767) {
    newView = 'TabView';
  }
  return newView;
}
const actions = {
  CANCEL_LISTENERS: 'CANCEL_LISTENERS',
  CANCEL_LISTENERS_SUCCESS: 'CANCEL_LISTENERS_SUCCESS',
  SET_CANCEL_LISTENERS: 'SET_CANCEL_LISTENERS',
  COLLAPSE_CHANGE: 'COLLAPSE_CHANGE',
  PERMANENT_COLLAPSE_CHANGE: 'PERMANENT_COLLAPSE_CHANGE',
  CHANGE_OPEN_KEYS: 'CHANGE_OPEN_KEYS',
  TOGGLE_ALL: 'TOGGLE_ALL',
  CHANGE_CURRENT: 'CHANGE_CURRENT',
  CLOSE_ALL: 'CLOSE_ALL',
  SELECT_ADDRESS: 'SELECT_ADDRESS',
  CHECK_APP_VERSION: 'CHECK_APP_VERSION',
  NEED_APP_RELOAD: 'NEED_APP_RELOAD',
  CHANGE_GENERAL_SETTINGS_KEY: 'CHANGE_GENERAL_SETTINGS_KEY',
  PAGE_WITH_ABSOLUTE_FOOTER_MOUNTED: 'PAGE_WITH_ABSOLUTE_FOOTER_MOUNTED',
  PAGE_WITH_ABSOLUTE_FOOTER_UNMOUNTED: 'PAGE_WITH_ABSOLUTE_FOOTER_UNMOUNTED',
  // CHECK_SERVICE_CONTRACT: 'CHECK_SERVICE_CONTRACT',
  FETCH_SERVICE_CONTRACT_SUCCESS: 'FETCH_SERVICE_CONTRACT_SUCCESS',
  FETCH_SERVICE_CONTRACT_ERROR: 'FETCH_SERVICE_CONTRACT_ERROR',
  ACCEPT_SERVICE_CONTRACT_REQUEST: 'ACCEPT_SERVICE_CONTRACT_REQUEST',
  ACCEPT_SERVICE_CONTRACT_SUCCESS: 'ACCEPT_SERVICE_CONTRACT_SUCCESS',
  ACCEPT_SERVICE_CONTRACT_ERROR: 'ACCEPT_SERVICE_CONTRACT_ERROR',
  SAVING_SERVICE_CONTRACT: 'SAVING_SERVICE_CONTRACT',
  FETCH_SYSTEM_UPDATES_CHANGELOG: 'FETCH_SYSTEM_UPDATES_CHANGELOG',
  FETCH_SYSTEM_UPDATES_CHANGELOG_SUCCESS: 'FETCH_SYSTEM_UPDATES_CHANGELOG_SUCCESS',
  FETCH_COMPLETE_SYSTEM_UPDATES_CHANGELOG_SUCCESS: 'FETCH_COMPLETE_SYSTEM_UPDATES_CHANGELOG_SUCCESS',
  FETCH_CHANGELOG_PAGE: 'FETCH_CHANGELOG_PAGE',
  FETCH_CHANGELOG_PAGE_SUCCESS: 'FETCH_CHANGELOG_PAGE_SUCCESS',
  FETCH_CHANGELOG_PAGE_ERROR: 'FETCH_CHANGELOG_PAGE_ERROR',
  SAVE_SYSTEM_UPDATE: 'SAVE_SYSTEM_UPDATE',
  SAVE_SYSTEM_UPDATE_SUCCESS: 'SAVE_SYSTEM_UPDATE_SUCCESS',
  SAVE_SYSTEM_UPDATE_ERROR: 'SAVE_SYSTEM_UPDATE_ERROR',
  GENERATE_CHANGELOG_ITEMS: 'GENERATE_CHANGELOG_ITEMS',
  GENERATE_CHANGELOG_ITEMS_SUCCESS: 'GENERATE_CHANGELOG_ITEMS_SUCCESS',
  GENERATE_CHANGELOG_ITEMS_ERROR: 'GENERATE_CHANGELOG_ITEMS_ERROR',
  SYNC_CHANGELOG_FROM_JIRA: 'SYNC_CHANGELOG_FROM_JIRA',
  SYNC_CHANGELOG_FROM_JIRA_SUCCESS: 'SYNC_CHANGELOG_FROM_JIRA_SUCCESS',
  SYNC_CHANGELOG_FROM_JIRA_ERROR: 'SYNC_CHANGELOG_FROM_JIRA_ERROR',
  SET_CHANGELOG_STATUS: 'SET_CHANGELOG_STATUS',
  SET_CHANGELOG_STATUS_SUCCESS: 'SET_CHANGELOG_STATUS_SUCCESS',
  SET_CHANGELOG_STATUS_ERROR: 'SET_CHANGELOG_STATUS_ERROR',
  DISCARD_CHANGELOG_ENTRY: 'DISCARD_CHANGELOG_ENTRY',
  DISCARD_CHANGELOG_ENTRY_SUCCESS: 'DISCARD_CHANGELOG_ENTRY_SUCCESS',
  DISCARD_CHANGELOG_ENTRY_ERROR: 'DISCARD_CHANGELOG_ENTRY_ERROR',
  SEND_CHANGELOG_FEEDBACK: 'SEND_CHANGELOG_FEEDBACK',
  SEND_CHANGELOG_FEEDBACK_SUCCESS: 'SEND_CHANGELOG_FEEDBACK_SUCCESS',
  SEND_CHANGELOG_FEEDBACK_ERROR: 'SEND_CHANGELOG_FEEDBACK_ERROR',
  FETCH_MY_CHANGELOG_FEEDBACK: 'FETCH_MY_CHANGELOG_FEEDBACK',
  FETCH_MY_CHANGELOG_FEEDBACK_SUCCESS: 'FETCH_MY_CHANGELOG_FEEDBACK_SUCCESS',
  FETCH_MY_CHANGELOG_FEEDBACK_ERROR: 'FETCH_MY_CHANGELOG_FEEDBACK_ERROR',
  FETCH_CHANGELOG_FEEDBACK: 'FETCH_CHANGELOG_FEEDBACK',
  FETCH_CHANGELOG_FEEDBACK_SUCCESS: 'FETCH_CHANGELOG_FEEDBACK_SUCCESS',
  FETCH_CHANGELOG_FEEDBACK_ERROR: 'FETCH_CHANGELOG_FEEDBACK_ERROR',
  MARK_CHANGELOG_FEEDBACK_READ: 'MARK_CHANGELOG_FEEDBACK_READ',
  MARK_CHANGELOG_FEEDBACK_READ_SUCCESS: 'MARK_CHANGELOG_FEEDBACK_READ_SUCCESS',
  MARK_CHANGELOG_FEEDBACK_READ_ERROR: 'MARK_CHANGELOG_FEEDBACK_READ_ERROR',
  MARK_CHANGELOG_SEEN: 'MARK_CHANGELOG_SEEN',
  FETCH_ACTIVE_CHANGELOG_SUCCESS: 'FETCH_ACTIVE_CHANGELOG_SUCCESS',
  SET_ACTIVE_CHANGELOG: 'SET_ACTIVE_CHANGELOG',
  SET_ACTIVE_CHANGELOG_SUCCESS: 'SET_ACTIVE_CHANGELOG_SUCCESS',
  SET_ACTIVE_CHANGELOG_ERROR: 'SET_ACTIVE_CHANGELOG_ERROR',
  FETCH_CHANGELOG_LIKES: 'FETCH_CHANGELOG_LIKES',
  FETCH_CHANGELOG_LIKES_SUCCESS: 'FETCH_CHANGELOG_LIKES_SUCCESS',
  FETCH_CHANGELOG_LIKES_ERROR: 'FETCH_CHANGELOG_LIKES_ERROR',
  TOGGLE_CHANGELOG_LIKE: 'TOGGLE_CHANGELOG_LIKE',
  TOGGLE_CHANGELOG_LIKE_SUCCESS: 'TOGGLE_CHANGELOG_LIKE_SUCCESS',
  TOGGLE_CHANGELOG_LIKE_ERROR: 'TOGGLE_CHANGELOG_LIKE_ERROR',
  FETCH_SYSTEM_ALERT_SUCCESS: 'FETCH_SYSTEM_ALERT_SUCCESS',
  UPDATE_SYSTEM_ALERT: 'UPDATE_SYSTEM_ALERT',
  UPDATE_SYSTEM_ALERT_SUCCESS: 'UPDATE_SYSTEM_ALERT_SUCCESS',
  UPDATE_SYSTEM_ALERT_ERROR: 'UPDATE_SYSTEM_ALERT_ERROR',
  SCROOL_WRAPPER_TO_BOTTOM: 'SCROOL_WRAPPER_TO_BOTTOM',
  CHANGE_SAVED_ALL_CHANGES: 'CHANGE_SAVED_ALL_CHANGES',
  DISCARD_SAVED_ALL_CHANGES: 'DISCARD_SAVED_ALL_CHANGES',
  CHANGE_SPECIFIC_SAVED_ALL_CHANGES_FIELD: 'CHANGE_SPECIFIC_SAVED_ALL_CHANGES_FIELD',
  CHECK_MAINTENANCE: 'CHECK_MAINTENANCE',
  SET_MAINTENANCE: 'SET_MAINTENANCE',
  CHECK_SHOW_POPOVER_COMPONENT_TO_PRINT: 'CHECK_SHOW_POPOVER_COMPONENT_TO_PRINT',
  SET_SHOW_POPOVER_COMPONENT_TO_PRINT: 'SET_SHOW_POPOVER_COMPONENT_TO_PRINT',
  SAVE_ON_CACHE_SHOW_POPOVER_COMPONENT_TO_PRINT: 'SAVE_ON_CACHE_SHOW_POPOVER_COMPONENT_TO_PRINT',
  SET_PREVENT_CLOSE_MODAL_VISIBLE: 'SET_PREVENT_CLOSE_MODAL_VISIBLE',
  CHANGE_FLOAT_BUTTON_VALUE: 'CHANGE_FLOAT_BUTTON_VALUE',
  // Admin Module Manager Actions
  SEARCH_PROFESSIONALS_ADMIN: 'SEARCH_PROFESSIONALS_ADMIN',
  SEARCH_PROFESSIONALS_ADMIN_SUCCESS: 'SEARCH_PROFESSIONALS_ADMIN_SUCCESS',
  SEARCH_PROFESSIONALS_ADMIN_ERROR: 'SEARCH_PROFESSIONALS_ADMIN_ERROR',
  SEARCH_PROFESSIONALS_ADMIN_CLEAR: 'SEARCH_PROFESSIONALS_ADMIN_CLEAR',
  FETCH_PROFESSIONAL_DATA_ADMIN: 'FETCH_PROFESSIONAL_DATA_ADMIN',
  FETCH_PROFESSIONAL_DATA_ADMIN_SUCCESS: 'FETCH_PROFESSIONAL_DATA_ADMIN_SUCCESS',
  FETCH_PROFESSIONAL_DATA_ADMIN_ERROR: 'FETCH_PROFESSIONAL_DATA_ADMIN_ERROR',
  FETCH_PROFESSIONAL_EMAIL_ADMIN: 'FETCH_PROFESSIONAL_EMAIL_ADMIN',
  FETCH_PROFESSIONAL_EMAIL_ADMIN_SUCCESS: 'FETCH_PROFESSIONAL_EMAIL_ADMIN_SUCCESS',
  FETCH_PROFESSIONAL_EMAIL_ADMIN_ERROR: 'FETCH_PROFESSIONAL_EMAIL_ADMIN_ERROR',
  FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN: 'FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN',
  FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN_SUCCESS: 'FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN_SUCCESS',
  FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN_ERROR: 'FETCH_PROFESSIONAL_AUTH_STATUS_ADMIN_ERROR',
  SET_USER_ENABLED_ADMIN: 'SET_USER_ENABLED_ADMIN',
  SET_USER_ENABLED_ADMIN_SUCCESS: 'SET_USER_ENABLED_ADMIN_SUCCESS',
  SET_USER_ENABLED_ADMIN_ERROR: 'SET_USER_ENABLED_ADMIN_ERROR',
  FETCH_PROFESSIONAL_MODULES_ADMIN: 'FETCH_PROFESSIONAL_MODULES_ADMIN',
  FETCH_PROFESSIONAL_MODULES_ADMIN_SUCCESS: 'FETCH_PROFESSIONAL_MODULES_ADMIN_SUCCESS',
  FETCH_PROFESSIONAL_MODULES_ADMIN_ERROR: 'FETCH_PROFESSIONAL_MODULES_ADMIN_ERROR',
  UPDATE_PROFESSIONAL_MODULES_ADMIN: 'UPDATE_PROFESSIONAL_MODULES_ADMIN',
  UPDATE_PROFESSIONAL_MODULES_ADMIN_SUCCESS: 'UPDATE_PROFESSIONAL_MODULES_ADMIN_SUCCESS',
  UPDATE_PROFESSIONAL_MODULES_ADMIN_ERROR: 'UPDATE_PROFESSIONAL_MODULES_ADMIN_ERROR',
  FETCH_MODULE_HISTORY_ADMIN: 'FETCH_MODULE_HISTORY_ADMIN',
  FETCH_MODULE_HISTORY_ADMIN_SUCCESS: 'FETCH_MODULE_HISTORY_ADMIN_SUCCESS',
  FETCH_MODULE_HISTORY_ADMIN_ERROR: 'FETCH_MODULE_HISTORY_ADMIN_ERROR',
  CLEAR_MODULE_MANAGER_STATE: 'CLEAR_MODULE_MANAGER_STATE',
  cancelListeners: () => ({
    type: actions.CANCEL_LISTENERS,
  }),
  setRemoveListener: (value) => ({
    type: actions.SET_CANCEL_LISTENERS,
    payload: value,
  }),
  toggleCollapsed: () => ({
    type: actions.COLLAPSE_CHANGE,
  }),
  toggleCollapsedPermanent: (forceOpenSidebar = false) => ({
    type: actions.PERMANENT_COLLAPSE_CHANGE,
    payload: forceOpenSidebar,
  }),
  toggleAll: (width, height) => {
    const view = getView(width);
    const collapsed = view !== 'DesktopView';
    return {
      type: actions.TOGGLE_ALL,
      collapsed,
      view,
      height,
    };
  },
  changeOpenKeys: (openKeys) => ({
    type: actions.CHANGE_OPEN_KEYS,
    openKeys,
  }),
  changeCurrent: (current) => ({
    type: actions.CHANGE_CURRENT,
    current,
  }),
  closeAll: () => ({ type: actions.CLOSE_ALL }),
  selectAddressGlobally: (address) => ({
    type: actions.SELECT_ADDRESS,
    payload: address,
  }),
  checkAppVersion: () => ({
    type: actions.CHECK_APP_VERSION,
  }),
  changeGeneralSettingsKey: (key = '') => ({
    type: actions.CHANGE_GENERAL_SETTINGS_KEY,
    payload: key,
  }),
  pageMounted: (path) => ({
    type: actions.PAGE_WITH_ABSOLUTE_FOOTER_MOUNTED,
    payload: path,
  }),
  pageUnmounted: (path) => ({
    type: actions.PAGE_WITH_ABSOLUTE_FOOTER_UNMOUNTED,
    payload: path,
  }),
  // checkServiceContract: () => ({
  //   type: actions.CHECK_SERVICE_CONTRACT,
  // }),
  acceptServiceContract: () => ({
    type: actions.ACCEPT_SERVICE_CONTRACT_REQUEST,
  }),
  getSystemUpdatesChangelog: (completeChangelog) => ({
    type: actions.FETCH_SYSTEM_UPDATES_CHANGELOG,
    payload: {
      completeChangelog,
    },
  }),
  fetchChangelogPage: (reset) => ({
    type: actions.FETCH_CHANGELOG_PAGE,
    payload: { reset: Boolean(reset) },
  }),
  saveSystemUpdate: (systemUpdate) => ({
    type: actions.SAVE_SYSTEM_UPDATE,
    payload: systemUpdate,
  }),
  generateChangelogItems: (version) => ({
    type: actions.GENERATE_CHANGELOG_ITEMS,
    payload: { version },
  }),
  syncChangelogFromJira: () => ({
    type: actions.SYNC_CHANGELOG_FROM_JIRA,
  }),
  setChangelogStatus: (entryKey, status) => ({
    type: actions.SET_CHANGELOG_STATUS,
    payload: { entryKey, status },
  }),
  discardChangelogEntry: (entryKey, version, published) => ({
    type: actions.DISCARD_CHANGELOG_ENTRY,
    payload: { entryKey, version, published: Boolean(published) },
  }),
  sendChangelogFeedback: (entryKey, version, message) => ({
    type: actions.SEND_CHANGELOG_FEEDBACK,
    payload: {
      entryKey,
      version,
      message,
    },
  }),
  fetchMyChangelogFeedback: () => ({
    type: actions.FETCH_MY_CHANGELOG_FEEDBACK,
  }),
  fetchChangelogFeedback: () => ({
    type: actions.FETCH_CHANGELOG_FEEDBACK,
  }),
  markChangelogSeen: (entryKey) => ({
    type: actions.MARK_CHANGELOG_SEEN,
    payload: { entryKey },
  }),
  setActiveChangelog: (entryKey) => ({
    type: actions.SET_ACTIVE_CHANGELOG,
    payload: { entryKey },
  }),
  fetchChangelogLikes: (entryKeys) => ({
    type: actions.FETCH_CHANGELOG_LIKES,
    payload: { entryKeys: entryKeys || [] },
  }),
  toggleChangelogLike: (entryKey, itemId, liked) => ({
    type: actions.TOGGLE_CHANGELOG_LIKE,
    payload: {
      entryKey,
      itemId,
      liked,
    },
  }),
  markChangelogFeedbackRead: (feedback, read) => ({
    type: actions.MARK_CHANGELOG_FEEDBACK_READ,
    payload: {
      id: feedback.id,
      actorUid: feedback.actorUid,
      entryKey: feedback.entryKey,
      read,
    },
  }),
  scrollWrapperToBottom: () => ({
    type: actions.SCROOL_WRAPPER_TO_BOTTOM,
  }),
  changeSavedAllChanges: (id, obj) => ({
    type: actions.CHANGE_SAVED_ALL_CHANGES,
    payload: {
      id,
      obj,
    },
  }),
  changeSpecificSavedAllChanges: (id, field, fieldValue) => ({
    type: actions.CHANGE_SPECIFIC_SAVED_ALL_CHANGES_FIELD,
    payload: {
      id,
      field,
      fieldValue,
    },
  }),
  saveOnCacheAlreadyShownPopoverComponentToPrint: () => ({
    type: actions.SAVE_ON_CACHE_SHOW_POPOVER_COMPONENT_TO_PRINT,
  }),
  setPreventCloseModalVisible: (value) => ({
    type: actions.SET_PREVENT_CLOSE_MODAL_VISIBLE,
    payload: {
      value,
    },
  }),
  updateSystemAlerts: (alert) => ({
    type: actions.UPDATE_SYSTEM_ALERT,
    payload: alert,
  }),
  changeFloatButtonValues: (value) => ({
    type: actions.CHANGE_FLOAT_BUTTON_VALUE,
    payload: value,
  }),
  // Admin Module Manager Action Creators
  searchProfessionalsAdmin: (searchTerm) => ({
    type: actions.SEARCH_PROFESSIONALS_ADMIN,
    payload: { searchTerm },
  }),
  clearProfessionalsSearch: () => ({
    type: actions.SEARCH_PROFESSIONALS_ADMIN_CLEAR,
  }),
  fetchProfessionalDataAdmin: (professionalUid) => ({
    type: actions.FETCH_PROFESSIONAL_DATA_ADMIN,
    payload: { professionalUid },
  }),
  fetchProfessionalModulesAdmin: (professionalUid) => ({
    type: actions.FETCH_PROFESSIONAL_MODULES_ADMIN,
    payload: { professionalUid },
  }),
  updateProfessionalModulesAdmin: (professionalUid, modules, maxCustomHealthProfessionals, freePeriods) => ({
    type: actions.UPDATE_PROFESSIONAL_MODULES_ADMIN,
    payload: {
      professionalUid, modules, maxCustomHealthProfessionals, freePeriods,
    },
  }),
  fetchModuleHistoryAdmin: (professionalUid) => ({
    type: actions.FETCH_MODULE_HISTORY_ADMIN,
    payload: { professionalUid },
  }),
  clearModuleManagerState: () => ({
    type: actions.CLEAR_MODULE_MANAGER_STATE,
  }),
  setUserEnabledAdmin: (uid, enabled) => ({
    type: actions.SET_USER_ENABLED_ADMIN,
    payload: { uid, enabled },
  }),
};
export default actions;
